import { render } from "./Subscriptions.vue?vue&type=template&id=6e672fb8"
import script from "./Subscriptions.vue?vue&type=script&lang=js"
export * from "./Subscriptions.vue?vue&type=script&lang=js"

import "./Subscriptions.vue?vue&type=style&index=0&id=6e672fb8&lang=scss"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__